export enum GeofenceTypeEnum{
  CIRCLE = "circle",
  POLYGON = "polygon",
  INDOOR = "indoor",
  NONE = "none"
};
